module.exports = __webpack_public_path__ + "/img/Kangoo-rezultati.62857684.webp";